import { KibsiClient } from './base';
export class DeploymentKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'deployment');
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { siteId, versionId, appId, ids, includeDefinition } = criteria ?? {};
        return this.get(`/deployments`, {
            ...requestConfig,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            params: {
                ...requestConfig?.params,
                continuationToken,
                pageSize,
                sort,
                siteId,
                versionId,
                appId,
                ids: ids?.join(','),
                includeDefinition,
            },
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/deployments/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/deployments', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/deployments/${entity.deploymentId}`, entity, requestConfig);
    }
    delete(deploymentId, requestConfig) {
        return this.del(`/deployments/${deploymentId}`, requestConfig);
    }
    launch(deploymentId, requestConfig) {
        return this.put(`/deployments/${deploymentId}/launch`, undefined, requestConfig);
    }
    stop(deploymentId, deploymentStop, requestConfig) {
        return this.put(`/deployments/${deploymentId}/stop`, deploymentStop, requestConfig);
    }
    restart(deploymentId, requestConfig) {
        return this.put(`/deployments/${deploymentId}/restart`, undefined, requestConfig);
    }
    resumeSchedule(deploymentId, requestConfig) {
        return this.put(`/deployments/${deploymentId}/resume-schedule`, undefined, requestConfig);
    }
    discardDraft(deploymentId, requestConfig) {
        return this.del(`/deployments/${deploymentId}/draft`, requestConfig);
    }
    vdbEndpoint(deploymentId, requestConfig) {
        return this.get(`/deployments/${deploymentId}/vdb-endpoint`, requestConfig);
    }
    getLaunch(launchId, requestConfig) {
        return this.get(`/launch/${launchId}`, requestConfig);
    }
    upgradeAndLaunch(toVersionId, deploymentIds, requestConfig) {
        return this.post(`/deployments/upgrade/${toVersionId}/launch`, { deploymentIds }, requestConfig);
    }
    listEvents(deploymentId, paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { action } = criteria ?? {};
        return this.get(`/deployments/${deploymentId}/events`, {
            ...requestConfig,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            params: {
                ...requestConfig?.params,
                continuationToken,
                pageSize,
                sort,
                action,
            },
        });
    }
    async getRuntimeConfigs(deploymentId, requestConfig) {
        const resp = await this.get(`/deployments/${deploymentId}/launch/configs.zip`, {
            ...requestConfig,
            params: {
                redirect: false,
            },
        });
        return resp;
    }
}
//# sourceMappingURL=deployment.js.map